import type { SaleChange } from '@src/domains/sale-changes/types/saleChange';

export const resolveSaleChangeAmounts = (
  saleChange?: SaleChange | null,
): { downAmount?: number; upAmount?: number } => {
  if (!saleChange) {
    return { downAmount: undefined, upAmount: undefined };
  }

  const downItem = saleChange.metadata?.down?.patch?.items?.[saleChange?.saleItemId ?? ''];
  const upItem = saleChange.metadata?.up?.patch?.items?.[saleChange?.saleItemId ?? ''];

  return { downAmount: downItem?.priceCents, upAmount: upItem?.priceCents };
};
